module.exports = __webpack_public_path__ + "static/media/reflexer.62e05b96.png";